import { render } from "./TermsFollowList.vue?vue&type=template&id=5415b6ba&scoped=true"
import script from "./TermsFollowList.vue?vue&type=script&lang=js"
export * from "./TermsFollowList.vue?vue&type=script&lang=js"

import "./TermsFollowList.vue?vue&type=style&index=0&id=5415b6ba&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5415b6ba"]])

export default __exports__